module.exports = __webpack_public_path__ + "img/value3.c9a1b90e.png";